export default __webpack_public_path__ + "static/media/left.6a2fde1c.svg";